import { ActionBarPrimitive } from '@assistant-ui/react'
import { InfoIcon } from 'lucide-react'
import { type FC } from 'react'
import { Alert, AlertDescription } from '#app/components/ui/alert'

export const AIDisclaimer: FC = () => {
	return (
		<ActionBarPrimitive.Root hideWhenRunning>
			<Alert className="mt-3 border-muted-foreground/20 bg-muted/50">
				<InfoIcon className="size-4 text-muted-foreground" />
				<AlertDescription className="text-base text-muted-foreground">
					AI-assistenten är till för att ge vägledning i det kliniska arbetet,
					men den kan ha brister och ge felaktig information. Använd den därför
					som ett stöd och inte som ersättning till din kliniska bedömning.
				</AlertDescription>
			</Alert>
		</ActionBarPrimitive.Root>
	)
}
